import { render, staticRenderFns } from "./DataInputSelectcolor.vue?vue&type=template&id=1000bff2&scoped=true&"
import script from "./DataInputSelectcolor.vue?vue&type=script&lang=js&"
export * from "./DataInputSelectcolor.vue?vue&type=script&lang=js&"
import style0 from "./DataInputSelectcolor.vue?vue&type=style&index=0&id=1000bff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1000bff2",
  null
  
)

export default component.exports